import { useEffect, useState } from 'react';
import { MOBILE_VIEWPORT } from 'containers/App/constants';
import useWindowSize from './useWindowSize';

function useIsMobile() {
  const { width } = useWindowSize();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (width < MOBILE_VIEWPORT) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [width, isMobile]);

  return isMobile;
}

export default useIsMobile;
